import React from "react";
import { Text } from "@react-three/drei";
import Avatar from "./Avatar";
import { teamOf, FONTS } from "../game/theme";

// Where the i-th player of a team stands. side: -1 = left, +1 = right.
export function avatarPosition(side, i) {
  const col = i % 3;
  const row = Math.floor(i / 3);
  return [side * (3.3 + col * 1.4), 0, 0.7 + row * 1.6];
}

// Platform + avatars for one team.
const TeamStage = ({
  teamKey = "left",
  players = [],
  bumps = {},
  highlightId = null,
  moodFor,
  showLabel = true,
}) => {
  const side = teamKey === "left" ? -1 : 1;
  const team = teamOf(teamKey);

  return (
    <group>
      {/* platform disc */}
      <mesh position={[side * 4.5, -0.05, 1.4]} rotation={[0, 0, 0]}>
        <cylinderGeometry args={[2.9, 3.2, 0.22, 40]} />
        <meshStandardMaterial color={team.dark} metalness={0.5} roughness={0.5} />
      </mesh>
      <mesh position={[side * 4.5, 0.07, 1.4]} rotation={[-Math.PI / 2, 0, 0]}>
        <torusGeometry args={[2.9, 0.05, 8, 48]} />
        <meshStandardMaterial
          color={team.color}
          emissive={team.color}
          emissiveIntensity={1.3}
          toneMapped={false}
        />
      </mesh>

      {showLabel && (
        <Text
          font={FONTS.display}
          position={[side * 4.5, 0.35, 4]}
          rotation={[-0.4, 0, 0]}
          fontSize={0.42}
          color={team.color}
          outlineWidth={0.02}
          outlineColor="#000000"
          anchorX="center"
        >
          {team.name.toUpperCase()}
        </Text>
      )}

      {players.map((player, i) => (
        <Avatar
          key={player.id || i}
          player={player}
          position={avatarPosition(side, i)}
          bump={bumps[player.id] || 0}
          highlight={highlightId === player.id}
          mood={moodFor ? moodFor(player) : "idle"}
          scale={0.68}
        />
      ))}
    </group>
  );
};

export default TeamStage;
